import { render, staticRenderFns } from "./FarmRegistration.vue?vue&type=template&id=b3e981f8"
import script from "./FarmRegistration.vue?vue&type=script&lang=js"
export * from "./FarmRegistration.vue?vue&type=script&lang=js"
import style0 from "./FarmRegistration.vue?vue&type=style&index=0&id=b3e981f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports